<template>
 <div class="shipmentdata row m-0 mb-2">
  <div class="input__model1group mr-3" style="width: 16%">
    <p class="textdefault">Packages Quantity</p>
    <b-input-group>
      <b-form-input
        type="number"
        placeholder="0"
        :formatter="formatMaxLenght10"
        v-model="item.qty"
        min="0"
        trim
        @keyup="emitToParent('CALCULATE')"
      ></b-form-input>
      <!-- <template #append>
       
      </template> -->
    </b-input-group>
  </div>
  <div class="input__model1group input__model1group--dropdown mr-3" style="width: 20%">
    <p class="textdefault">Cargo Packaging Type</p>
    <div class="options__defaultdropdown">
      <b-dropdown :text="item.satuan">
        <b-dropdown-item v-for="(unit, y) in optionQtyUnit" :key="y"
                          @click="emitToParent('SETTYPE', unit.value, indexShipmentData)">
          {{ unit.name }}
        </b-dropdown-item>
      </b-dropdown>
      <img class="imgabsolute"
            src = "@/assets/image/image/gray-down-arrow@3x.png">
    </div>
  </div>
  <div class="input__model1group mr-3"  style="width: 19%">
    <p class="textdefault">Weight <span>Per {{modifyUnitText(item.satuan)}}</span></p>
    <b-input-group append="Kg">
      <b-form-input
        type="number"
        v-model="item.weight"
        placeholder="0"
        :formatter="formatMaxLenght10"
        min="0"
        @keyup="emitToParent('CALCULATE')"
        @onblur="emitToParent('CHECKERROR')"
      />
    </b-input-group>
  </div>
  <div class="input__model1group"  style="width: 36%">
    <p class="textdefault">Size <span>Per {{modifyUnitText(item.satuan)}}</span></p>
    <b-input-group append="Cm">
      <b-form-input v-model="item.length"
                    placeholder="L"
                    aria-label="Length"
                    type="number"
                    min="0"
                    :formatter="formatMaxLenght6"
                    @keyup="emitToParent('CALCULATE')"
                    @onblur="emitToParent('CHECKERROR')" />
      <b-form-input v-model="item.width"
                    placeholder="W"
                    aria-label="Width"
                    type="number"
                    min="0"
                    :formatter="formatMaxLenght6"
                    @keyup="emitToParent('CALCULATE')"
                    @onblur="emitToParent('CHECKERROR')" />
      <b-form-input v-model="item.height"
                    placeholder="H"
                    aria-label="Height"
                    type="number"
                    min="0"
                    :formatter="formatMaxLenght6"
                    @keyup="emitToParent('CALCULATE')"
                    @onblur="emitToParent('CHECKERROR')" />
    </b-input-group>
  </div>
  <div v-if="indexShipmentData === 0" class="row mx-0 ml-2 shipmentdata__buttonaddremove"
       @click="emitToParent('ADDCONTAINER')">
    <img src="@/assets/image/icon/circle-plus-gray.svg" />
  </div>
  <div v-else
       class="row mx-0 ml-2 shipmentdata__buttonaddremove"
        @click="emitToParent('REMOVECONTAINER', indexShipmentData)">
    <img src="@/assets/image/icon/circle-x-gray.svg" />
  </div>
 </div>
</template>

<script>

export default {
  props: {
    indexShipmentData: Number,
    item: Object,
    optionQtyUnit: Array
  },
  data () {
    return {}
  },
  methods: {
    modifyUnitText (unit) {
      let currentText = 'Quantity'
      switch (unit) {
        case 'Boxes': currentText = 'Box'
          break
        case 'Cartons': currentText = 'Carton'
          break
        case 'Cases': currentText = 'Case'
          break
        case 'Drums': currentText = 'Drum'
          break
        case 'Packages': currentText = 'Package'
          break
        case 'Palletes': currentText = 'Pallete'
          break
        case 'Charters': currentText = 'Charter'
          break
        case 'Units': currentText = 'Unit'
          break
        case 'CBM': currentText = 'CBM'
          break
        default:
          break
      }
      return currentText
    },

    emitToParent (type, value, idx) {
      if (type === 'ADDCONTAINER') {
        this.$emit('addContainer')
      } else if (type === 'REMOVECONTAINER') {
        this.$emit('removeContainer', value)
      } else if (type === 'SETTYPE') {
        const arr = {
          type: value,
          index: idx
        }
        this.$emit('setType', arr)
      } else if (type === 'CALCULATE') {
        this.$emit('calcTotalShipment')
      } else if (type === 'CHECKERROR') {
        this.$emit('checkError')
      }
    },

    formatMaxLenght10 (e) {
      return String(e).substring(0, 10)
    },
    formatMaxLenght6 (e) {
      return String(e).substring(0, 6)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/requestShipment/components/ShipmentData.vue